import React, { FunctionComponent } from 'react';
import { FlexboxContainer } from '@components/ui/common';
import { Button } from '@shopify/polaris';
import styled from 'styled-components';

const Container = styled(FlexboxContainer)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;

const HeaderText = styled.div`
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 2rem;
`;

const FailCatchAll: FunctionComponent = () => {
  const handleStartOver = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie =
        name +
        '=;Path=/; Domain=.givz.com; SameSite=None; Secure; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }

    window.location.href = document.referrer;
  };

  return (
    <Container>
      <HeaderText>Sorry, something went wrong.</HeaderText>
      <Button size="large" onClick={handleStartOver}>
        Clear cookies and start over
      </Button>
    </Container>
  );
};

export default FailCatchAll;
